<template>
  <van-overlay v-show="isShow">
    <div class="wrapper">
      <div id="prize" :class="needAnimate ? 'active':'showBox'">
        <div class="card" :class="{showBox:!needAnimate,award_info:popInfo.type==1}">
          <div class="content">
            <img :src="popInfo.headImg" class="prizeImg"/>
            <h3 class="title">{{popInfo.titleName}}</h3>
            <p class="infoTxt" v-if="popInfo.infoTxt">{{popInfo.infoTxt}}</p>
            <!-- 手机号 -->
            <input type="number" v-model.trim="tel" maxlength="11" placeholder="请填写您的手机号" class="telInput" @input="tel=tel.slice(0,11)" v-if="prizeResult.prizeType == 1&&variant == 'winPrize'"/>
            <button class="submitBtn" @click="submitEvent">{{popInfo.btnTxt}}</button>
            <div class="close" :class="{showBox:!needAnimate}"><img src="../images/closeIcon.png" @click="close"></div>
          </div>
        </div>
        <p class="circle-small"></p>
        <p class="circle-big"></p>
        <div class="raybox"><p class="ray"></p></div>
      </div>
    </div>
  </van-overlay>
</template>

<script>
export default {
  emits: ["cancel"],
  props: {
    prizeResult:{
      type: Object,
      default: ()=>{
        return{}
      }
    },
    platform:{
      type: String,
      default:''
    },
  },
  computed:{
    popInfo(){
      const getBtnTxt = ()=>{
        if(this.prizeResult.prizeType == 1){//实物
          return '提交'
        }else if(this.prizeResult.prizeType == 2){//虚物
          return ((this.platform == 'APP' && this.prizeResult.appReceivePrizeUrl) || ((this.platform == 'PC' || this.platform == 'H5') && this.prizeResult.webReceivePrizeUrl) || (this.platform == 'WXAPP' && this.prizeResult.miniProgramReceivePrizeUrl)) ? '去使用':'我知道了'
        }
      }
      return {
        winPrize: {//签到成功
          "headImg":this.popData.prizeImgUrl,
          "titleName":"签到成功",
          "infoTxt":`已发放【${this.popData.prizeName}X${this.popData.prizeCount}】`,
          "btnTxt":getBtnTxt(),
        },
        prizeInfo: {//奖品信息
          "headImg":this.popData.prizeImgUrl,
          "titleName":`${this.popData.prizeName}X${this.popData.prizeCount}`,
          "infoTxt":this.popData.prizeDesc,
          "btnTxt":"我知道了",
          "type":1
        },
      }[this.variant];
    },
    needAnimate(){
      // return this.variant == 'winPrize' ? true:false
      return false
    }
  },
  data(){
    return{
      tel:"",
      isShow:false,
      variant: "prizeInfo",
      popData:{}
    }
  },
  methods: {
    cancel() {
      this.close();
      this.$emit("cancel");
    },
    close() {
      this.isShow = false;
    },
    open({ variant = "usedTime" } = {},data) {
      this.isShow = true;
      this.variant = variant;
      this.popData = data.awardDTO
      console.log(data,'info');
    },
    submitEvent(){//提交
      if(this.prizeResult.prizeType == 1&&this.variant == 'winPrize'){//中奖到实物，需要填手机号todo
        if(this.tel.length != 11){
          this.$toast({
            type:"text",
            message:"请填写正确的手机号",
            // getContainer:"#luckyWheelWarp"
          });
          // return false;
        }else{//提交信息
          this.$emit("submitWinInfo",this.tel,this.prizeResult.winRecordId,(data)=>{
            if(!data){//接口失败
              this.$toast({
                type:"text",
                message:"提交失败",
                // getContainer:"#luckyWheelWarp"
              });
            }else{//成功
              this.$toast({
                type:"text",
                message:"提交成功",
                // getContainer:"#luckyWheelWarp"
              });
              this.cancel();
            }
          })
        }
      }else if(this.prizeResult.prizeType == 2&&this.variant == 'winPrize'){//中奖到虚拟
        this.cancel();
      }else{
        this.close();
      }
    }
  }
}
</script>

<style lang="less" scoped>
#prize {
  position: fixed;
  width: 100%;
  height: 80%;
  top: 50%;
  left: 50%;
  transform: translate3d(-50%, -50%, 0);
  z-index: 20;

  &.active {
    display: block;
  }

  .card {
    position: absolute;
    width: 311px;
    background: #FFFFFF url("../images/winPrizeBg.png") left top no-repeat;
    background-size: contain;
    border-radius: 20px;
    opacity: 0;
    transform: scale(0);
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    z-index: 5;
    &.showBox{
      opacity: 1;
    }
    .content{
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 24px 20px;
      .prizeImg{
        display: block;
        width: 88px;
        height: 88px;
        margin-bottom: 6px;
      }
      .title{
        font-size: 20px;
        font-weight: 500;
        line-height: 24px;
        text-align: center;
        color: #222222;
      }
      .infoTxt{
        font-size: 14px;
        line-height: 18px;
        text-align: center;
        color: #4C4F54;
        margin-top: 12px;
      }
      .telInput{
        width: 100%;
        height: 36px;
        font-size: 14px;
        padding: 0 12px;
        box-sizing: border-box;
        color: #1A1A1A;
        border-radius: 6px;
        background: rgba(241, 241, 241, 0.9);
        margin-top: 12px;
        border: none;
        &::input-placeholder {
          color: #AFB3BA;
        }
        &::-webkit-input-placeholder {
          color: #AFB3BA;
        }
      }
      .submitBtn{
        display: block;
        width: 167px;
        height: 52px;
        line-height: 52px;
        border-radius: 26px;
        background: linear-gradient(180deg, #FFB245 1%, #FF4E0E 99%);
        font-size: 20px;
        font-weight: 500;
        line-height: 24px;
        text-align: center;
        color: #FFFFFF;
        border: none;
        margin-top: 24px;
        &.disabled{
          opacity: 0.6;
        }
      }
    }
  }
  .award_info{
    background: #ffffff;
  }

  .circle-small, .circle-big {
    position: absolute;
    width: 472px;
    height: 472px;
    opacity: 0;
    transform: scale(0);
    top: 50%;
    left: 50%;
    margin: -236px 0 0 -236px;
    background: url(../images/circle-small.png) no-repeat;
    background-size: 100% 100%;
    z-index: 4;
  }

  .circle-big {
    width: 501px;
    height: 501px;
    margin: -251px 0 0 -251px;
    background-image: url(../images/circle-big.png);
    background-size: 100% 100%;
    z-index: 3;
  }


  .raybox {
    position: absolute;
    width: 812px;
    height: 812px;
    top: 50%;
    left: 50%;
    opacity: 0;
    margin: -406px 0 0 -406px;
    z-index: 1;

    .ray {
      width: 100%;
      height: 812px;
      background: url(../images/light.png) center center no-repeat;
    }
  }

  .close {
    position: absolute;
    display: inline-block;
    padding: 8px;
    opacity: 0;
    right: 0;
    top: -30px;
    z-index: 5;
    &.showBox{
      opacity: 1;
    }
    img{
      width: 14px;
      height: 14px;
    }
  }

  .know {
    position: absolute;
    width: 200px;
    height: 60px;
    cursor: pointer;
    left: 50%;
    bottom: 5%;
    margin-left: -100px;
    z-index: 5;
  }
}

.active {
  .card {
    animation: cardAnimation 1.03s linear forwards;
  }

  .circle-small {
    animation: circleSmallAnimation 1.09s linear forwards;
  }

  .circle-big {
    animation: circleBigAnimation 1s linear forwards;
  }
  .raybox {
    animation: circleRayBoxAnimation 0.19s linear forwards;
  }

  .ray {
    animation: circleRayAnimation 10s linear forwards;
  }

  .close {
    animation: closeAnimation 0.24s 0.4s linear forwards;
  }
}

.shadow {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,.7);
  z-index: 10;
}

@keyframes cardAnimation {
  4.7% {
    opacity: 1;
    transform: translate(-50%, -50%) scale(0.1) rotateY(0deg);
  }
  25% {
    opacity: 1;
    transform: translate(-50%, -50%) scale(0.8) rotateY(288deg);
  }
  30% {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1.1) rotateY(360deg);
  }
  100% {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1) rotateY(360deg);
  }
}

@keyframes closeAnimation {
  100% {
    opacity: 1;
  }
}

@keyframes circleSmallAnimation {
  13% {
    opacity: 0;
    transform: scale(0.4);
  }
  18% {
    opacity: 1;
    transform: scale(0.57);
  }
  27% {
    opacity: 1;
    transform: scale(0.9);
  }
  33% {
    opacity: 1;
    transform: scale(0.9);
  }
  100% {
    opacity: 0;
    transform: scale(1);
  }
}

@keyframes circleBigAnimation {
  15% {
    opacity: 0;
    transform: scale(0.4);
  }
  22% {
    opacity: 1;
    transform: scale(0.6);
  }
  32% {
    opacity: 1;
    transform: scale(0.9);
  }
  100% {
    opacity: 0;
    transform: scale(1);
  }
}

@keyframes circleRayBoxAnimation {
  0% {
    opacity: 0;
    transform: scale(0.2);
  }
  50% {
    opacity: 0.5;
    transform: scale(1);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes circleRayAnimation {
  0% {
    transform: rotate(0deg);
  }
  50% {
    opacity: 1;
    transform: rotate(360deg);
  }
  60% {
    opacity: 0;
    transform: rotate(360deg);
  }
  100% {
    opacity: 0;
  }
}
</style>
